<template>
  <div class="embeb-track-container">
    <div class="embeb-track-loader">
      <Loader :loading="!loaded" />
    </div>
    <div v-show="loaded && track.id" class="embeb-track">
      <!-- <h1>Embed Track</h1> -->
      <MuzikEmbeddedPlayer :type="'track'" />
    </div>
    <div v-if="loaded && !track.id" class="embeb-track-empty">
      <div class="cover">
        <img src="@/assets/images/empty-content/img-empty.svg" title="empty content" alt="empty content">
      </div>
      <div class="text">
        <div class="title">
          {{ $t('DUMMY.NOT_FOUND_TITLE') }}
        </div>
        <div class="desp">
          {{ $t('DUMMY.NOT_FOUND_DESP') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TrackService from '@/assets/services/TrackService'
import { displayTrackName, displayComposerName, displayPerformerName } from '@/assets/helpers/TrackHelper'
import Loader from '@/components/common/Loader'
import MuzikEmbeddedPlayer from '@/components/MuzikEmbeddedPlayer'
export default {
  name: 'EmbedTrackById',
  components: {
    Loader,
    MuzikEmbeddedPlayer
  },
  directives: {},
  props: {},
  data() {
    return {
      loaded: false,
      track: {}
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    // default meta data, update after fetched article
    title() {
      const titlePostfix = `${this.$t('LISTEN.TITLE')} | MUZIK AIRs`
      const localeTitle = this.displayTrackName(this.track)
      return this.track && this.track.id
        ? `${localeTitle} | ${titlePostfix}`
        : `${this.$t('TRACK.TITLE')} | ${titlePostfix}`
    },
    description() {
      let localeDescription = ''
      if (this.track) {
        let composerName = ''
        if (this.track.movement && this.track.movement.work) {
          composerName = this.displayComposerName(this.track.movement.work.people, this.$i18n.locale)
        }
        let trackName = this.displayTrackName(this.track, this.$i18n.locale)
        localeDescription = `${composerName} - ${trackName}`
      }
      return localeDescription || this.$t('TRACK.TITLE')
    },
    keywords() {
      let keywordsAry = []
      if (this.track && this.track.movement && this.track.movement.work) {
        keywordsAry.push(this.displayTrackName(this.track))
        keywordsAry.push(this.displayComposerName(this.track.movement.work.people))
        this.track.performers.forEach(perfermer => {
          keywordsAry.push(this.displayPerformerName(perfermer.people))
        })
      }
      return keywordsAry.join(', ')
    },
    cover() {
      return this.track && this.track['file_link']
        ? this.track['file_link']
        : '/img/cover-social/listen/png'
    },
    canonicalURL() {
      return this.track && this.track.id
        ? `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/embed/tracks/${this.track.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    structuredData() {
      if (this.track && this.track.id) {
        return [
          {
            '@context': 'http://schema.org',
            '@type': 'MusicRecording',
            '@id': this.canonicalURL,
            'url': this.canonicalURL,
            'duration': this.track.duration,
            'name': this.trackName,
            'inAlbum': {
              '@type': 'MusicAlbum',
              '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/composers/works/${this.track.movement.work.id}`,
              'name': this.workName
            },
            'byArtist': {
              '@type': 'MusicGroup',
              '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/composers/${this.track.movement.work.people.id}`,
              'name': this.composerName
            },
            'recordingOf': {
              '@type': 'MusicComposition',
              'name': this.trackName
            }
          },
          {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'item': {
                  '@id': `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`,
                  'name': this.$t('LISTEN.TITLE')
                }
              }
            ]
          }
        ]
      } else {
        return []
      }
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.initEmbedTrackPage()
  },
  updated() {},
  methods: {
    displayTrackName,
    displayComposerName,
    displayPerformerName,
    async initEmbedTrackPage() {
      this.loaded = false
      const trackId = this.$route.params.id
      const track = await TrackService.getTrackById(trackId)
      if (track) {
        this.track = track
        this.$store.commit('SET_TRACK_TO_QUEUE', track)
        this.$store.commit('SET_PLAYER_INDEX', 0)
        // this.$nextTick(() => {
        //   // after loaded
        //   this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        // })
        this.loaded = true
      } else {
        this.loaded = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.embeb-track {
  &-loader {
    display: block;
    text-align: center;
  }
  &-empty {
    width: 100%;
    margin: 4px auto;
    padding: 6px;
    text-align: center;
    border-radius: 12px;
    border: solid 2px $grey-ec;
    .cover , .text {
      display: inline-block;
      vertical-align: top;
      max-width: 380px;
    }
    .text {
      margin-left: 24px;
    }
    .title {
      font-size: 20px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-50;

      // margin-bottom: 12px;
      text-align: left;
    }
    .desp {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.6;
      color: $grey-50;
      text-align: left;
    }
    img {
      height: 80px;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .embeb-track {
    &-empty {
      margin: 2px auto;
      padding: 4px;
      .cover , .text {
        width: 100%;
        margin-left: 0;
      }
      .title {
        font-size: 16px;
        margin-bottom: 0;
        text-align: center;
      }
      .desp {
        // font-size: 12px;
        display: none;
      }
      img {
        height: 60px;
      }
    }
  }
}
</style>
